import React, {useContext} from 'react';
import {injectIntl} from "react-intl";
import FormContext from "formContext";
import SelectField from "@FormElements/SelectField";
import { useSpecialismsList } from "i18nHelper";

function SpecialismSelectFields({intl, settings, ...rest}) {
  const {state, name} = settings || {};
  const {onChange} = rest;
  const {currentStep, setFormData} = useContext(FormContext);
  const specialisms = useSpecialismsList(intl.locale);

  if (settings.state && settings.state.specialism && isNaN(settings.state.specialism)) {
    let specialismIndex;
    let specialism = specialisms.find(spec => spec.name == settings.state.specialism);
    let newListLang;
    let newListSpecialism;
    specialismIndex = specialisms.findIndex(spec => spec.name == settings.state.specialism);
    if (!specialism) {
      newListLang = (intl.locale === "fr") ? "en" : "fr";
      newListSpecialism = useSpecialismsList(newListLang);
      specialism = newListSpecialism.find(spec => spec.name == settings.state.specialism);
      specialismIndex = newListSpecialism.findIndex(spec => spec.name == settings.state.specialism);
    }

    if (specialism) { //update to ID
      settings.state.specialism = specialism.id;
    }

    if (settings.state.sub_specialism && isNaN(settings.state.sub_specialism)) {
      let sub_specialism = specialism.nested.find(spec => spec.name == settings.state.sub_specialism);
      if (!sub_specialism) {
        sub_specialism =newListSpecialism[specialismIndex].nested.find(spec => spec.name == settings.state.sub_specialism);
      }

      if (sub_specialism) { // update to ID
        settings.state.sub_specialism = sub_specialism.id;
      }
    }
  }


  const SpecialismField = () => {
    if (!Array.isArray(specialisms)) {
      return null;
    }
    const specialismOptions = [];
    specialismOptions.push({ value: "", label: intl.formatMessage({id: 'SelectField.EmptyOption.Label'}) });
    specialisms.sort((a, b) => a.name.localeCompare(b.name)).forEach((specialism) => {
      specialismOptions.push({
        value: specialism.id,
        label: specialism.name,
      });
    });

    settings.options = specialismOptions;
    return (
      <SelectField
        settings={settings}
        {...rest}
        onChange={handleSpecialismChange}
      />
    )
  };

  const handleSpecialismChange = event => {
    if (settings && settings.subspecialism && settings.subspecialism.name) {
      setFormData(prev => {
        if (!prev[currentStep]) {
          prev[currentStep] = {};
        }
        const subSpecialismName = settings.subspecialism.name;
        prev[currentStep][subSpecialismName] = '';
        return {
          ...prev
        }
      });
    }
    onChange(event);
  };

  const SubSpecialismField = () => {

    if (!specialisms || !Object.keys(specialisms).length) {
      return null;
    }

    let selectedSpecialism;
    if (state && state.hasOwnProperty(name) && state[name] && state[name].length) {
      selectedSpecialism = state[name];
    }

    const subSpecialismOptions = [];
    const currentSpec = specialisms.find(spec => spec.id === selectedSpecialism);
    if (selectedSpecialism && specialisms.length) {
      if (currentSpec && Array.isArray(currentSpec.nested)) {
        subSpecialismOptions.push({ value: "", label: intl.formatMessage({id: 'SelectField.EmptyOption.Label'}) });
        currentSpec.nested.sort((a, b) => a.name.localeCompare(b.name)).forEach(subSpec => {
          subSpecialismOptions.push({ value: subSpec.id, label: subSpec.name });
        });
      }
    }
    if (!subSpecialismOptions.length) {
      return '';
    }
    settings.subspecialism.options = subSpecialismOptions;
    return (
      <SelectField
        settings={{...settings, ...settings.subspecialism}}
        {...rest}
      />
    )
  };

  return (
    <>
      <SpecialismField />
      <SubSpecialismField />
    </>
  )
}

export default injectIntl(SpecialismSelectFields);
